var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
var _excluded = ["active", "className", "children", "mobile", "transparent"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import React, { Children } from "react";
import classNames from "classnames";
import { Row } from "@riseart/antd-provider";
import { headerCls, headerWrapperCls, headerActiveCls, headerTransparentCls, headerMobileLeftCls, headerMobileRightCls, headerMenuCls } from "./Header.less";
var columns = {
  mobile: [{
    className: headerMobileLeftCls
  }, {}, {
    className: classNames(headerMobileRightCls, headerMenuCls)
  }],
  desktop: [{}, {
    className: classNames(headerMenuCls)
  }, {
    className: headerMenuCls
  }]
};
var Header = /* @__PURE__ */ __name(function Header2(_ref) {
  var _ref$active = _ref.active, active = _ref$active === void 0 ? false : _ref$active, className = _ref.className, children = _ref.children, _ref$mobile = _ref.mobile, mobile = _ref$mobile === void 0 ? false : _ref$mobile, _ref$transparent = _ref.transparent, transparent = _ref$transparent === void 0 ? false : _ref$transparent, restProps = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */ React.createElement("header", _extends({
    className: classNames(headerCls, _defineProperty(_defineProperty({}, headerActiveCls, active), headerTransparentCls, transparent), className)
  }, restProps), /* @__PURE__ */ React.createElement(Row, {
    justify: mobile ? "end" : "space-between",
    className: headerWrapperCls
  }, Children.map(children, function(child, index) {
    return /* @__PURE__ */ React.cloneElement(child, columns[mobile ? "mobile" : "desktop"][index]);
  })));
}, "Header");
export {
  Header
};
